// extracted by mini-css-extract-plugin
module.exports = {"root":"_2FGWY","text":"_3mlxD"};